// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

import translate from "@insite/client-framework/Translate";
import { CsrRepModel } from "@insite/client-framework/Types/ApiModels";
import setPlantFieldValue from "@store/Framework/Store/Greif/Pages/ContactUs/Handlers/SetPlantFieldValues";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";

const enum fields {
    label = "label",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    plantSelection: state.greif.pages.contactUs.plantFieldValues,
    currentSession: state.context.session,
    needRefresh: state.greif.pages.contactUs.resetValues,
});

const mapDispatchToProps = {
    setPlantFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AvailablePlantSelectionStyles {
    plantselectionSelect?: SelectPresentationProps;
}

export const availablePlantSelectionStyles: AvailablePlantSelectionStyles = {};

export const styles = availablePlantSelectionStyles;

const AvailablePlantSelection: React.FC<Props> = ({
    needRefresh,
    fields,
    plantSelection,
    currentSession,
    setPlantFieldValue,
}) => {
    const { label, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [plantErrorMessage, setPlantErrorMessage] = React.useState("");

    const { customerServiceRepresentativeList } = currentSession.properties;
    const plantsCsr: CsrRepModel[] = JSON.parse(customerServiceRepresentativeList);
    const emptyPlant: CsrRepModel = {
        address: "",
        cellPhone: "",
        email: "",
        firstName: "",
        lastName: "",
        officePhone: "",
        role: "",
        isDefaultPlant: false,
        plant: "",
        plantDisplayName: "",
    };
    const isDefaultPlant = plantsCsr.find(e => e.isDefaultPlant);

    React.useEffect(() => {
        setPlantFieldValue({ value: emptyPlant });
    }, [needRefresh]);

    React.useEffect(() => {
        contactFormContext.validators.plantCsr = validatePlant;
        if (plantSelection.plant) {
            validatePlant();
        }
    }, [plantsCsr]);

    React.useEffect(() => {
        contactFormContext.validators.plantCsr = validatePlant;
    }, [isRequired]);

    const validatePlant = () => {
        const errorMessage =
            isRequired && !plantSelection.plant ? (siteMessage("Field_Required", label) as string) : "";
        setPlantErrorMessage(errorMessage);
        return !errorMessage;
    };

    const plantChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const searchForPlant = plantsCsr.find(e => e.plant === event.target.value);
        setPlantFieldValue({ value: searchForPlant || emptyPlant });
    };

    return (
        <Select
            {...styles.plantselectionSelect}
            label={label}
            required={isRequired}
            value={plantSelection.plant || ""}
            error={plantErrorMessage}
            onChange={plantChangeHandler}
        >
            <option value="">{translate("Please select value")}</option>
            {plantsCsr.map(plant => (
                <option key={plant.plant} value={plant.plant}>
                    {plant.plantDisplayName}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AvailablePlantSelection),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Plant Selection",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
